module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAZCAMAAAD+KQUWAAAAaVBMVEX0xVwAAAD0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVz0xVyaKaJsAAAAInRSTlOwAPPpa2MG+dKjgnwuJx0OzY6H9u7juZZWT0wVwsF3dENBcPzq7AAAALVJREFUKM+90suuwiAYReF/FUpbe7P1rue63/8hDQMlmooz15AvIYRsw9vrSqxVrpW5rBemfFZneW2nrJ+MOcMTBu3r14N5+N8t6u4PvGkKjM0CNyNhkkl1B8ftk26P0NWKruoHhv0D7wf4rRQ99jWA39x142H4lu6uooR+ffuUHspCyWN2IczxxmoOXNKxbrkzdE3ddHB2Sp46jMTGg7Tocm0f+tZp0VMf9eLN/lZv9kuZ3f8VWLpSVmwM6T8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_bottom_email.png
// module id = eAgD
// module chunks = 1